import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import { pluck } from 'rxjs/operators'
import { MB_PAYMENT_MODE_NORMALIZER, MbPaymentModeAdapter } from '../connectors'

@Injectable({
  providedIn: 'root',
})
export class MbOccPaymentModeAdapter implements MbPaymentModeAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load (cartId: string) {
    return this.http.get(this.getEndpoint(cartId)).pipe(
      pluck('paymentModes'),
      this.converter.pipeable(MB_PAYMENT_MODE_NORMALIZER)
    )
  }

  protected getEndpoint (cartId: string) {
    return this.occEndpoints.buildUrl('paymentModes', {
      urlParams: {
        cartId
      },
    })
  }
}
